/**
 * 根据vue指令种的expression取得目标值所在的对象和key
 * @param viewModel 上下文
 * @param expression 指令表达式
 */
export default (viewModel, expression) => {
  let keys = expression.split('.')
  let target = viewModel
  let key = keys[keys.length - 1]

  for (let i = 0, l = keys.length; i < l - 1; i++) {
    target = target[keys[i]]
  }
  return {
    viewModel: viewModel,
    target: target,
    key: key
  }
}



// WEBPACK FOOTER //
// ./src/packages/utils/src/transformContext.js